import * as d3 from 'd3';
import template from './chartDiagram.html';

export default class ChartDiagramDirective {
  constructor() {
    'ngInject';
    this.replace = true;
    this.restrict = 'E';
    this.template = template;

    this.scope = {
      onClick: '&'
    };
  }

  link($scope, $element, $attrs) {
    this.$scope = $scope;

    // Set default attributes
    this.maxValue = $attrs.maxValue || 100;
    this.value = $attrs.value || 0;
    this.baseHeight = $attrs.baseHeight || 200;
    this.className = $attrs.className;
    this.onClick = $scope.onClick;

    // Define canvas where to draw the diagram
    this.canvas = d3.select($element[0]);
    this.drawDiagram();
  }

  drawDiagram() {
    const { canvas, baseHeight, maxValue, value, onClick, $scope } = this;

    // Calculate the right block hight
    const height = (value / maxValue) * baseHeight;
    const container = canvas
      .append('svg')
      .attr('width', 80)
      .attr('height', baseHeight)
      .attr('viewBox', `0 0 80 ${baseHeight}`)
      .attr('preserveAspectRatio', 'xMidYMax meet');
    const rectangle = container
      .append('rect')
      .attr('class', this.className)
      .attr('x', 0)
      .attr('y', baseHeight - height)
      .attr('width', 80)
      .attr('height', height);

    // Handle click on bar
    rectangle.on('click', () => {
      onClick();
      $scope.$apply();
    });
  }
}
